import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManBindDevice(data) {
    return maintainRequest.post("/device/maintenanceMan/chargingPile/bindDevice", data)
}
